export const Props = () => ({
  //----------------------------------------------------------------------------
  //                              Цвет loader-а
  //----------------------------------------------------------------------------
  color: {
    type: String,
    required: false,
    default: 'white',
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                                 Размер Loder-а
  //----------------------------------------------------------------------------
  size: {
    type: Number,
    required: false,
    default: 25,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                                 Размер Loder-а
  //----------------------------------------------------------------------------
  weight: {
    type: Number,
    required: false,
    default: 5,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});